import React, { useState, useEffect, useRef } from 'react';
import Modal from 'react-bootstrap/Modal';
// HiArrowCircleRight/Left werden jetzt wahrscheinlich nicht mehr gebraucht,
// wenn wir die Standard-Swiper-Navigation nutzen. Kann aber drin bleiben.
import { HiArrowCircleRight, HiArrowCircleLeft } from "react-icons/hi";
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { IMAGE_URL } from '../App';

// Swiper React Komponenten importieren
import { Swiper, SwiperSlide } from 'swiper/react';

// Swiper Module importieren
import { Navigation, A11y } from 'swiper/modules'; // Navigation und Accessibility

// Swiper Styles importieren
import 'swiper/css';
import 'swiper/css/navigation';
// import 'swiper/css/pagination'; // Optional

// --- NewsDetail Komponente bleibt unverändert ---
// (Code der NewsDetail Komponente hier einfügen - siehe vorherige Antworten)
function NewsDetail({ show, onHide, news }) {
  // ... (Gleicher Code wie zuvor)
  const [screenSize, setScreenSize] = useState(window.innerWidth);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [PicturesPerPage, setPicturesPerPage] = useState(3);

  const handleResize = () => {
    setScreenSize(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (screenSize < 1000) {
      setPicturesPerPage(1);
      setCurrentIndex(0);
    } else {
      setPicturesPerPage(3);
       setCurrentIndex(0);
    }
  }, [screenSize]);

  useEffect(() => {
    setCurrentIndex(0);
  }, [show, news]);

  if (!news) {
    return null;
  }

  const formattedDate = (date) => {
    const options = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    };
    return new Date(date).toLocaleDateString('de-DE', options);
  };

  const nextImage = () => {
     if (news.gallery && currentIndex + PicturesPerPage < news.gallery.length) {
         setCurrentIndex((prevIndex) => prevIndex + 1);
     }
  };

  const prevImage = () => {
     if (currentIndex > 0) {
         setCurrentIndex((prevIndex) => prevIndex - 1);
     }
  };

   const handleClose = () => {
    onHide();
  };

  const visibleGalleryPictures = news?.gallery?.length > 0
    ? news.gallery.slice(currentIndex, currentIndex + PicturesPerPage)
    : [];


  return (
    <Modal size="lg" show={show} onHide={handleClose} centered className='no-carot'>
       <Modal.Header className='bg-light justify-content-center border border-0 rakete-rot' closeButton>
        <Modal.Title className='rakete-font fw-semibold text-uppercase'>{news?.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className='bg-light shadow'>
        {news && (
         <>
            <div className='mx-2'>
              <img src={`${IMAGE_URL}/uploads/${news.picture}`} className="img-fluid rounded shadow-sm border" alt={`News: ${news.title}`} />
              <p className="fs-7 fw-semibold text-end mt-2">{formattedDate(news.date)}</p>
              <p className='fw-semibold fs-5 text-center'>{news.subtitle}</p>
              <div dangerouslySetInnerHTML={{ __html: news.content }} />
            </div>

            {news.gallery && news.gallery.length > 0 && (
              <div className="mx-auto mb-5 container-fluid position-relative">
                <h4 className="rakete-font fw-semibold pt-3 ms-4 rakete-rot text-center mb-3">Galerie</h4>
                <div className="row justify-content-center align-items-center position-relative" style={{ minHeight: '150px' }}> {/* Min height für Buttons */}

                   {currentIndex > 0 && (
                    <button
                      className="carousel-control-prev"
                      type="button"
                      onClick={prevImage}
                      style={{ zIndex: 10, width: 'auto', left: '-5px', top: '50%', transform: 'translateY(-50%)', border: 'none', background: 'none' }}
                    >
                      <HiArrowCircleLeft className='rakete-rot fs-1' />
                      <span className="visually-hidden">Previous</span>
                    </button>
                  )}

                  {visibleGalleryPictures.map((picture, index) => (
                    <div key={index} className={screenSize >= 1000 ? "col-4" : "col-12"}>
                       <div className={screenSize < 1000 ? "mx-auto my-2 text-center" : "h-100"} style={{ maxWidth: '300px', display: 'inline-block' }}>
                        <img src={`${IMAGE_URL}/uploads/${picture}`} className="card-img-top rounded news-ratio" alt={`Galeriebild ${index + 1}`} style={{aspectRatio: '1 / 1', objectFit: 'cover'}}/>
                      </div>
                    </div>
                  ))}

                  {currentIndex + PicturesPerPage < news.gallery.length && (
                    <button
                      className="carousel-control-next"
                      type="button"
                      onClick={nextImage}
                      style={{ zIndex: 10, width: 'auto', right: '-5px', top: '50%', transform: 'translateY(-50%)', border: 'none', background: 'none' }}
                    >
                      <HiArrowCircleRight className='rakete-rot fs-1' />
                      <span className="visually-hidden">Next</span>
                    </button>
                  )}
                </div>
              </div>
            )}
          </>
        )}
      </Modal.Body>
      <Modal.Footer className='border border-0 fs-7'>Verfasser: {news?.author}</Modal.Footer>
    </Modal>
  );
}


// --- Angepasste News Komponente (Turnier im Swiper) ---
function News() {
  const [selectedNews, setSelectedNews] = useState(null); // Für das Modal
  const [showDetail, setShowDetail] = useState(false);
  const [swiperContent, setSwiperContent] = useState([]); // Ein State für alle Swiper-Inhalte
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // --- Daten holen und kombinieren ---
  useEffect(() => {
    setLoading(true);
    const fetchNewsAndTournaments = async () => {
      try {
        const [newsResponse, tournamentsResponse] = await Promise.all([
          axios.get('/api/News'),
          axios.get('/api/Tournaments')
        ]);

        const sortedNews = newsResponse.data.data
            .sort((a, b) => a.index - b.index)
            .map(news => ({ ...news, isTournament: false })); // Flag hinzufügen

        const upcomingTournaments = tournamentsResponse.data.data
          .filter(tournament => !tournament.completed && tournament.published)
          .sort((a, b) => new Date(a.date) - new Date(b.date));

        const nearestTournament = upcomingTournaments.length > 0
            ? { ...upcomingTournaments[0], isTournament: true } // Flag hinzufügen
            : null;

        // Kombiniere Turnier (falls vorhanden) und News
        const combined = nearestTournament ? [nearestTournament, ...sortedNews] : [...sortedNews];

        setSwiperContent(combined);
        setLoading(false);
      } catch (error) {
        console.log(error);
        setLoading(false);
      }
    };
    fetchNewsAndTournaments();
  }, []);

  // --- Klick-Handler (prüft jetzt isTournament Flag) ---
  const handleSlideClick = (item) => {
    if (item.isTournament) {
      navigate(`/tournament/${item._id}`);
    } else {
      setSelectedNews(item);
      setShowDetail(true);
    }
  };

  const handleHideDetail = () => {
    setShowDetail(false);
    setSelectedNews(null);
  };

  // --- Ladezustand ---
  if (loading) {
    return <div className="text-center p-5">Lade News...</div>;
  }

  // --- Breakpoints für Swiper (vereinfacht, da kein statisches Element mehr) ---
  const breakpoints = {
      320: { slidesPerView: 1, spaceBetween: 15 }, // Mehr Abstand auf Mobile
      768: { slidesPerView: 2, spaceBetween: 20 },
      992: { slidesPerView: 3, spaceBetween: 25 }, // Evtl. 3 schon früher
      1200: { slidesPerView: 3, spaceBetween: 30 }, // Oder 4 auf sehr großen? Teste 3.
      // 1400: { slidesPerView: 4, spaceBetween: 30 }, // Beispiel für 4 Slides
  };

  // Bestimme die maximale Anzahl sichtbarer Slides aus den Breakpoints für die Loop-Bedingung
  const getMaxSlidesPerView = (bps) => {
      return Math.max(...Object.values(bps).map(bp => bp.slidesPerView));
  }
  const maxSlides = getMaxSlidesPerView(breakpoints);


  return (
    <div className="bg-light shadow mb-5">
      <div className="container-fluid position-relative px-md-4"> {/* Padding für Container */}
        <h4 className="rakete-font fw-semibold pt-3 mb-3 rakete-rot anne">NEWS</h4> {/* Weniger Margin Bottom */}

        {/* Kein separates Row/Col mehr für Turnier vs. Swiper */}
        {swiperContent.length > 0 ? (
           <Swiper
              // Module
              modules={[Navigation, A11y]}
              // Navigation (Pfeile)
              navigation
              // Responsive Breakpoints
              breakpoints={breakpoints}
              // Loop nur wenn genug Slides für die größte Ansicht
              loop={swiperContent.length > maxSlides}
              // Accessibility
              a11y={{ enabled: true, prevSlideMessage: 'Vorherige Folie', nextSlideMessage: 'Nächste Folie' }}
              className="instagram-swiper py-3" // Padding unten für evtl. Pagination oder Platz
           >
              {swiperContent.map((item) => (
                 <SwiperSlide key={item._id} className="h-auto pb-2" style={{ display: 'flex' }}> {/* h-auto + flex für variable Höhe, pb für Schatten */}
                    {/* Conditional Rendering der Karte basierend auf isTournament */}
                     <div
                        className="card news-card shadow h-100 hover w-100" // w-100 hinzugefügt
                        onClick={() => handleSlideClick(item)}
                        style={{ cursor: 'pointer' }} // Zeiger verdeutlicht Klickbarkeit
                     >
                        <img
                           src={`${IMAGE_URL}/uploads/${item.picture}`}
                           className="card-img-top news-ratio" // Behalte das Seitenverhältnis bei
                           alt={item.isTournament ? `Turnier: ${item.title}` : `News: ${item.title}`}
                        />
                        <div className="card-body d-flex flex-column justify-content-center align-items-center">
                           {item.isTournament ? (
                              <>
                                 <h5 className="text-center fs-6 text-uppercase fw-bold mb-1">Jetzt Anmelden</h5>
                                 <p className="text-center text-muted small mt-0 mb-0">{item.title}</p>
                              </>
                           ) : (
                              <h5 className="text-center fs-6 text-uppercase mb-0">{item.title}</h5>
                           )}
                        </div>
                    </div>
                 </SwiperSlide>
              ))}
           </Swiper>
        ) : (
          // Fallback, wenn keine Inhalte vorhanden sind
          <div className="text-center p-4 text-muted">
            Aktuell keine News verfügbar.
          </div>
        )}
      </div>

      {/* --- NewsDetail Modal --- */}
      {selectedNews && (
         <NewsDetail show={showDetail} onHide={handleHideDetail} news={selectedNews} />
      )}
    </div>
  );
}

export default News;